export default __webpack_public_path__ + "static/media/143.41bd233c.png";